<template>
  <div class="default-menu sidenav-menu">
    <div class="default-menu__header">
      <div class="default-menu__header-top">
        <button type="button" class="default-menu__close" @click="$emit('close')">
          <IconComponent name="close" />
        </button>
      </div>
      <div class="sidenav-menu__header-links">
        <a @click.prevent="showLoginModal" href="#" class="sidenav-menu__header-link">
          <IconComponent name="profile" />
          <span>Вход</span>
        </a>
      </div>
    </div>
    <div class="default-menu__body sidenav-menu__body">
      <ul class="default-menu__links">
        <li v-for="(item, i) in list" :key="i">
          <router-link :to="item.route" class="default-menu__link">
            <span>{{ item.title }}</span>
            <IconComponent name="arrow-right-1" />
          </router-link>
        </li>
      </ul>
    </div>
    <div class="default-menu__footer sidenav-menu__footer">
      <IconAndTextComponent icon="call" :title="schedule" :value="phone" :link="phone | phone" :big="true" />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import IconAndTextComponent from "components/IconAndTextComponent.vue";
import LoginModal from "components/modals/components/LoginModal.vue";

export default {
  name: "SidenavMenu",
  data() {
    return {
      list: [
        {
          title: "Каталог",
          route: { name: "catalog" },
        },
        {
          title: "Контакты и реквизиты",
          route: { name: "" },
        },
        {
          title: "Магазины сети",
          route: { name: "" },
        },
        {
          title: "Условия оферты",
          route: { name: "" },
        },
        {
          title: "Вопросы и ответы",
          route: { name: "" },
        },
        // {
        //   title: "Акции",
        //   route: { name: "shares" },
        // },
        // {
        //   title: "Школа мам",
        //   route: { name: "school" },
        // },
        {
          title: "Доставка",
          route: { name: "" },
        },
        {
          title: "Способы оплаты",
          route: { name: "" },
        },
        {
          title: "Условия возврата",
          route: { name: "" },
        },
      ],
    };
  },
  computed: {
    phone() {
      if (
        this.$store.state.marketplace?.communications &&
        this.$store.state.marketplace.communications.length
      ) {
        return this.$store.state.marketplace.communications.find(
          (item) => item.type.code === this.$store.state._types.PHONE
        )?.value;
      }
      return undefined;
    },
    schedule() {
      return this.$store.state.marketplace?.schedule || undefined;
    },
  },
  methods: {
    showLoginModal() {
      this.$store.state._modals.push({
        component: LoginModal,
      });
      this.$emit("close");
    },
  },
  components: { IconAndTextComponent, IconComponent },
};
</script>

<style lang="stylus">
.sidenav-menu {
  &__header {
    &-links {
      display flex
      flex-direction column
      width 100%
      background: var(--white);
    }

    &-link {
      display flex
      align-items center
      gap 2px
      padding 10px 30px
      font-size 0.875em
      line-height: 145%;
      border-bottom 1px solid var(--gray)

      .icon {
        width 20px
        height 20px
      }
    }
  }
}
</style>
